/**
 * yappa-referral.js
 *
 * Captures the `?ref=CODE` param on any Yappa page load, drops a 90-day
 * cookie, and pushes the code into the visitor's cart as a note_attribute
 * so it lands on the order when they check out.
 *
 * The Rewards app's orders/paid webhook reads `note_attributes.referral_code`
 * to create the pending Referral row; orders/fulfilled qualifies + pays out
 * the advocate.
 *
 * Idempotent: only writes to the cart when the stored code differs from
 * what's already on it, so no wasted cart writes on every navigation.
 */
(function () {
  var COOKIE_NAME = 'yappa_ref';
  var COOKIE_MAX_AGE = 60 * 60 * 24 * 90; // 90 days
  var CODE_RE = /^[A-Z0-9]{4,12}$/;

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function writeCookie(name, value, maxAge) {
    document.cookie =
      name + '=' + encodeURIComponent(value) +
      '; Max-Age=' + maxAge +
      '; Path=/; SameSite=Lax';
  }

  // 1) Capture ?ref=CODE from URL if present + valid
  try {
    var params = new URLSearchParams(window.location.search);
    var incoming = (params.get('ref') || '').trim().toUpperCase();
    if (incoming && CODE_RE.test(incoming)) {
      writeCookie(COOKIE_NAME, incoming, COOKIE_MAX_AGE);
    }
  } catch (e) { /* older browsers — skip capture */ }

  // 2) Sync the cookie value into cart attributes so it survives to the order
  var stored = readCookie(COOKIE_NAME);
  if (!stored) return;

  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var current = cart && cart.attributes && cart.attributes.referral_code;
      if (current === stored) return null;
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { referral_code: stored } })
      });
    })
    .catch(function () { /* silent — attribution best-effort */ });
})();
